export default __webpack_public_path__ + "static/media/4.9bdb68a7.webp";